/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Keep_Open_WarningInputs */



/**
* | output |
* | --- |
* | "Please leave this window open until your export completes" |
*
* @param {Image_Export_Keep_Open_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_keep_open_warning = /** @type {((inputs?: Image_Export_Keep_Open_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Keep_Open_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez laisser cette fenetre ouverte jusqu'a la fin de l'exportation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte lassen Sie dieses Fenster so lange geöffnet, bis Ihr Export abgeschlossen ist.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Si prega di lasciare aperta questa finestra fino al completamento dell'esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, оставьте это окно открытым до завершения экспорта.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Deje esta ventana abierta hasta que se complete la exportación.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请保持此窗口打开，直到导出完成。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートが完了するまでこのウィンドウを開いたままにしてください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया निर्यात पूरा होने तक इस विंडो को खुला रखें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, deixe esta janela aberta até que a exportação seja concluída.")
	return /** @type {LocalizedString} */ ("Please leave this window open until your export completes")
});